import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css';

class PatientCareCenterAlSpeech extends React.Component {

    render() {
        if (this.props.all.length === 0) {
            return (<span />);
        }
        return (
            <div className={styles.body}>

                <div className={styles.section_row}>
                    <span className={styles.col1_bold_italic}>
                        {'Speech'}
                    </span>
                    {Object.keys(this.props.MLEXLOG)
                        .map(x => {
                            const exlog = this.props.MLEXLOG[x];
                            return (
                                <span key={exlog.XLNO} className={styles.col_bold_italic}>
                                    {exlog.XLTIMESPEECH ? exlog.XLTIMESPEECH + ' min.' : ''}
                                    {exlog.XLTIMESPEECHASSIST ? ' (assistant time: ' + exlog.XLTIMESPEECHASSIST + ' min.)' : ''}
                                </span>
                            )
                        })
                    }
                </div>

                {Object.keys(this.props.all)
                    .map(x => {
                        const row = this.props.all[x];
                        return (
                            <div key={row[0]} id={row[0]} className={styles.row} >
                                <span className={styles.col1_bold}>
                                    {row[0]}
                                </span>
                                {Object.keys(row)
                                    .filter(x => x > 0)
                                    .map(y => {
                                        const col = row[y];
                                        return (
                                            <span key={x + '_' + y} id={x + '_' + y} className={styles.col}>
                                                {col}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }

            </div>
        );
    }
}

function appendActivity(all, activity, index, visitCount) {
    let found = false;
    let val = activity.XLSPSETSREPS;
    val = activity.XLSPISGROUP ? val += ' *' : val;
    val = activity.XLSPASSIST ? val += ' @' : val;

    Object.keys(all)
        .forEach(x => {
            if (all[x][0] === 'to improve ' + activity.SPNAME + ': ' + activity.XLSPACTIVITY) {
                all[x][index + 1] = val;
                found = true;
            }
        });

    if (!found) {
        let row = new Array(visitCount + 1);
        row.fill('');
        row[0] = 'to improve ' + activity.SPNAME + ': ' + activity.XLSPACTIVITY;
        row[index + 1] = val;
        all.push(row);
    }

}

function mapStateToProps(state, ownprops) {
    let displayMode = state.ui.al[ownprops.epno].displayMode;
    let MLEXLOG = Object.keys(state.entities.al.MLEXLOG)
        .filter(x => state.entities.al.MLEXLOG[x].EPNO === ownprops.epno)
        .sort((a, b) => new Date(state.entities.al.MLEXLOG[a].TRTDATE).getTime() - new Date(state.entities.al.MLEXLOG[b].TRTDATE).getTime())
        .map(x => state.entities.al.MLEXLOG[x]);

    MLEXLOG = displayMode === -1 || MLEXLOG.length <= displayMode ? MLEXLOG : MLEXLOG.slice(MLEXLOG.length - displayMode, MLEXLOG.length);
    let index = 0;

    let all = [];
    let visitCount = MLEXLOG.length;

    Object.keys(MLEXLOG)
        .forEach(x => {

            Object.keys(state.entities.al.MLSPEECH)
                .filter(y => state.entities.al.MLSPEECH[y].XLSPXLNO === MLEXLOG[x].XLNO)
                .sort((a, b) => state.entities.al.MLSPEECH[a].XLSPNO - state.entities.al.MLSPEECH[b].XLSPNO)
                .forEach(z => {
                    appendActivity(all, state.entities.al.MLSPEECH[z], index, visitCount);
                });
            index++;
        });




    return {
        MLEXLOG,
        all,
        visitCount
    };
}

const connectedPatientCareCenterAlSpeech = connect(mapStateToProps)(PatientCareCenterAlSpeech);
export { connectedPatientCareCenterAlSpeech as PatientCareCenterAlSpeech };

